import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-22639031")

_pushScopeId("data-v-22639031")
const _hoisted_1 = { class: "d-list-item-root" }
const _hoisted_2 = { class: "item-header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "limit-pop-content" }
const _hoisted_6 = { class: "limit-pop-head" }
const _hoisted_7 = { class: "limit-pop-list" }
const _hoisted_8 = { class: "limit-pop-item-label" }
const _hoisted_9 = { class: "limit-pop-item-value" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", null, _toDisplayString(_ctx.iN('tables.multibet')), 1)
    ]),
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      (_ctx.selectedIndex === _ctx.itemIndex)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "limit-pop",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.iN('tables.selectlimit')), 1),
              _createVNode("div", _hoisted_7, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userLimits, (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "limit-pop-list-item",
                    key: index,
                    onClick: ($event: any) => (_ctx.enterDesk(item))
                  }, [
                    _createVNode("span", _hoisted_8, _toDisplayString(_ctx.iN('tables.limit')), 1),
                    _createVNode("span", _hoisted_9, _toDisplayString(item.downLimit) + " - " + _toDisplayString(item.upLimit), 1)
                  ], 8, ["onClick"]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})